import React from 'react';
import { Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import momencik from '../../../common/momencik';
import { CreateUpdatePricingDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import CompanyByNameOrNipSelector from '../Company/CompanyByNameOrNipSelector';

interface PricingBasicDataTabProps {
  pricing: CreateUpdatePricingDto;
  hasCompany: boolean;
  pricingId?: string;
  onPropertyChange: (obj: Partial<CreateUpdatePricingDto>) => void;
}

export const PricingBasicDataTab: React.FC<PricingBasicDataTabProps> = ({
  pricing,
  hasCompany,
  pricingId,
  onPropertyChange,
}) => {
  return (
    <Form className="d-grid gap-3">
      <FormRow controlId="name" label="Nazwa">
        <Form.Control
          type="text"
          value={pricing?.name || ''}
          onChange={e => onPropertyChange({ name: e.target.value })}
        />
      </FormRow>

      <FormRow controlId="company" label="Firma">
        <CompanyByNameOrNipSelector
          value={pricing?.companyId || ''}
          onChange={e => onPropertyChange({ companyId: e.value || '' })}
          readOnly={!!pricingId}
        />
      </FormRow>

      <FormRow controlId="startDate" label="Data rozpoczęcia">
        <Form.Control
          type="date"
          value={momencik(pricing.startDate, 'YYYY-MM-DD')}
          onChange={e =>
            onPropertyChange({
              startDate: e.target.value ? new Date(e.target.value) : undefined,
            })
          }
          disabled={!!pricingId}
        />
      </FormRow>

      <FormRow controlId="endDate" label="Data zakończenia">
        <Form.Control
          type="date"
          value={momencik(pricing?.endDate, 'YYYY-MM-DD')}
          onChange={e =>
            onPropertyChange({
              endDate: e.target.value ? new Date(e.target.value) : undefined,
            })
          }
          disabled={!!pricingId}
        />
      </FormRow>

      <FormRow controlId="percentageDiscount" label="Rabat (%)">
        <Form.Control
          type="text"
          value={pricing?.percentageDiscount || ''}
          onChange={e =>
            onPropertyChange({
              percentageDiscount: e.target.value,
            })
          }
          disabled={!hasCompany}
        />
      </FormRow>
    </Form>
  );
};
